import * as Yup from 'yup'
import i18n from 'i18n'

export const ProtocolsFormSchema = () => {
  return Yup.object().shape({
    name: Yup.string().required().label(i18n.t('protocols:name')),
    code: Yup.string().required().label(i18n.t('protocols:code')),
    description: Yup.string().label(i18n.t('protocols:description'))
  })
}

export const FilterProtocolsSchema = () => {
  return Yup.object().shape({
    name: Yup.string(),
    code: Yup.string()
  })
}
